<template>
  <div>
    <div class="w-full flex items-center justify-center my-5">
      <!-- <NumberInputControl @typing="typing" 
                @complete="complete" 
                v-bind:length="length"
                v-bind:value="value" />. -->
      <v-otp-input
        :is-disabled="false"
        ref="pinOTP"
        input-classes="otp-input"
        :input-type="'text'"
        inputmode="numeric"
        :num-inputs="length"
        v-model:value="value"
        :should-auto-focus="true"
        :should-focus-order="true"
        :key="otpInputKey"
        @on-complete="complete"
        @on-change="typing"
      />
    </div>
    <div class="px-4 pb-4 flex" v-if="!election">
      <ButtonControl v-on:click="validate" v-bind:disabled="disabled">
        {{ lang("lbl_0000016") }}
      </ButtonControl>
    </div>
    <div class="p-4 flex flex-row" v-else>
      <ButtonControl
        class="mr-3"
        outline
        v-on:click="$router.push('/dashboard')"
      >
        {{ lang("lbl_0000181") }}
      </ButtonControl>
      <ButtonControl v-on:click="validateElection" v-bind:disabled="disabled">
        {{ lang("lbl_0000372") }}
      </ButtonControl>
    </div>
    <div v-if="!election">
      <div v-show="show" class="pt-2 flex justify-center items-center pb-6">
        <div
          v-on:click="resend"
          v-text="lang('lbl_0000018')"
          class="text-sm leading-none underline text-primary font-semibold"
        ></div>
      </div>
      <div v-show="!show" class="pt-2 flex justify-center items-center pb-6">
        <div class="text-sm text-grey-darker">
          <span v-text="lang('lbl_0000019')"></span>
          <span v-text="min"></span>:<span v-text="formatSeconds(sec)"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
// import NumberInputControl from './../../components/controls/NumberInputControl.vue';
import OTP from "./../../services/OTP.js";
import mixin from "./../../mixin.js";
import GA from "@/services/GA";
import VOtpInput from "vue3-otp-input";

export default {
  name: "v-otp-control",
  mixins: [mixin],
  components: {
    ButtonControl,
    // NumberInputControl,
    VOtpInput,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
    pin: {
      type: String,
    },
    mobile: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    election: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      length: 6,
      value: "",
      disabled: true,
      show: false,
      min: 1,
      sec: 0,
      seconds: 1000,
      minutes: 2,
      t: null,
      otp_pin: null,
      otp_token: null,
      ga_code: this.$store.state.ga.code,
    };
  },
  mounted() {
    this.min = this.minutes;
    this.startTimer();
  },
  methods: {
    startTimer() {
      this.t = setInterval(function () {
        if (this.min == 0 && this.sec == 0) {
          this.show = true;
          this.reset(this.minutes);
          clearInterval(this.t);
        } else {
          if (this.sec == 0) {
            this.min--;
            this.sec = 59;
          } else {
            this.sec--;
          }
        }
      }, this.seconds);
    },
    formatSeconds(sec) {
      return sec.toString().padStart(2, "0");
    },
    reset(minute) {
      this.min = minute;
      this.sec = 0;
    },
    typing(value) {
      this.disabled = !(value.length == this.length);
    },
    complete(value) {
      this.value = value;
    },
    validate() {
      let state = this.$store.state;

      this.$emit("showloader");

      OTP.validate(this.type, this.pin, this.value)
        .then((response) => {
          let data = response.data.data;

          if (state.forgot_pin) {
            state.reset_pin.otp_token = data.otp_token;
            state.reset_pin.otp_pin = data.otp_pin;
            this.$router.push("/user/enroll/pin");
            return;
          }

          this.$emit("success", data);
        })
        .catch((error) => {
          this.$emit("failed", error?.response?.data?.message || "Invalid OTP");
          this.$emit("hideloader");
        })
        .finally(() => {
          this.value = "";
        });
    },
    validateElection() {
      this.$emit("showloader");
      let state = this.$store.state;
      GA.validateOtp(this.value, this.ga_code)
        .then((response) => {
          let data = response.data.data;
          state.ga.user.secret_key = data.secret_key;
          this.$emit("success", data);
        })
        .catch((error) => {
          this.value = "";
          this.$emit("failed", error.response.data.message);
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
    resend() {
      let state = this.$store.state;

      this.$emit("showloader");

      OTP.request(
        this.type,
        state.info.first_name,
        state.info.email,
        state.info.mobile_no,
        this.pin,
      )
        .then(() => {
          this.show = false;
          this.reset(this.minutes);
          this.$emit("reload");
          this.startTimer();
        })
        .catch((error) => {
          this.value = "";
          this.$emit(
            "failed",
            error?.response?.data?.message || "Failed to resend OTP",
          );
        })
        .finally(() => {
          this.$emit("hideloader");
        });
    },
  },
};
</script>
